/**
 * Returns true if a value is null, undefined, or NaN.
 */
export default function isNullish(value) {
  return value === null || value === undefined || value !== value;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/jsutils/isNullish.mjs
// module id = 523
// module chunks = 0